// extracted by mini-css-extract-plugin
export default {"popupContainer":"VideoPopUp_popupContainer__FDEvy","videoPopup":"VideoPopUp_videoPopup__cE0ro","videoCloseIcon":"VideoPopUp_videoCloseIcon__Rh-a1"};